const UserActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SET_CURRENT_USER_ROL: 'SET_CURRENT_USER_ROL',
    SET_CURRENT_USER_NIVEL: 'SET_CURRENT_USER_NIVEL',
    CAMBIAR_ESTATUS: 'CAMBIAR_ESTATUS',
    IMPLANTACION_ASPIRANTE: 'IMPLANTACION_ASPIRANTE',
    REGISTRO_TERMINADO: 'REGISTRO_TERMINADO',
    USER_LOGOUT: 'USER_LOGOUT',
    SET_ESTADO_DISTRITO_ASPIRANTE: 'SET_ESTADO_DISTRITO_ASPIRANTE',
    SET_FECHA_HORA_ACTIVIDAD:'SET_FECHA_HORA_ACTIVIDAD'
};

export default UserActionTypes;